import { AxiosError } from 'axios';
import { useBranchContext } from 'providers/BranchProvider';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axiosInstance from 'utils/axiosInterceptors';
import { toastConfig } from 'utils/toastConfig';
import { TProcurementReturns } from 'utils/types';
import * as Yup from 'yup';

interface ValidateReturnDetailsFormProps {
  procurementReturnId: number;
}

export type ValidateReturnDetailsFormHandle = {
  submit: () => Promise<boolean | undefined>;
};

const ValidateReturnDetailsForm = forwardRef<
  ValidateReturnDetailsFormHandle,
  ValidateReturnDetailsFormProps
>(({ procurementReturnId }, ref) => {
  const [returnDetails, setReturnDetails] = useState({
    reviewNotes: ''
  });
  const { selectedBranch } = useBranchContext();

  const handleSubmit = async () => {
    try {
      await axiosInstance.put(
        `/api/v1/${selectedBranch?.branchDomain}/procurementReturns/${procurementReturnId}/validate`,
        { reviewNotes: returnDetails.reviewNotes }
      );
      toast.success('Procurement validated', {
        autoClose: 2000,
        ...toastConfig
      });
      return true;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        error.inner.forEach(err => {
          toast.error(err.message, { ...toastConfig, autoClose: 3000 });
        });
      } else if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
      return false;
    }
  };

  const handleFormChange = <K extends keyof TProcurementReturns>(
    field: K,
    value: TProcurementReturns[K]
  ) => {
    setReturnDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  useImperativeHandle(ref, () => ({
    submit: handleSubmit
  }));

  return (
    <>
      <Form className="w-100">
        <Row className="mb-3">
          <Form.Label className="mb-2">Review Notes</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={returnDetails.reviewNotes}
            onChange={e => handleFormChange('reviewNotes', e.target.value)}
          />
        </Row>
      </Form>
    </>
  );
});

export default ValidateReturnDetailsForm;
